import { formatNumber } from "../../utils";

type TokenUsageProps = {
  tokensInput?: number;
  tokensOutput?: number;
};

export default function TokenUsage({
  tokensInput = 0,
  tokensOutput = 0,
}: TokenUsageProps) {
  if (tokensInput <= 0 && tokensOutput <= 0) return null;

  const totalTokens = tokensInput + tokensOutput;

  return (
    <div
      className="mt-2 flex items-center gap-1 text-xs text-gray-400"
      title={`Input: ${formatNumber(tokensInput)} / Output: ${formatNumber(tokensOutput)}`}
    >
      <span>{formatNumber(totalTokens)} tokens</span>
    </div>
  );
}
